import { ApiRoute } from 'api-base-refrence';
import { NestjsPageFilter } from 'nestjs-model-utility';
import { InformationApiRoute } from './information.api';
import { InformationModel } from 'src/domains/charts/model/information/information.model';

export class ChartGeographicAnalysisApiRoute extends ApiRoute {
  static apiName = '';
  static parent = InformationApiRoute;
  static urlPattern(
    filter?: NestjsPageFilter<keyof InformationModel.chartGeographicAnalysis>,
  ) {
    return '/geographic-analysis';
  }
}
